import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import appConfig from 'app-config';

export default class GatewayAvailabilityService {
    static checkAvailabilityBasedOnAddress(availabilityRequestDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayavailability'),
            'isProductAvailableBasedOnAddress',
            [availabilityRequestDTO],
            additionalHeaders
        );
    }

    static getAvailableProductsBasedOnPostalCodeExt(availabilityRequestDTO, additionalHeaders = {}) {
        const { portalCode } = appConfig;
        availabilityRequestDTO.portalCode_ML = (portalCode);
        return JsonRPCService.send(
            getProxiedServiceUrl('availability'),
            'getAvailableProductsBasedOnPostalCode',
            [availabilityRequestDTO],
            additionalHeaders
        );
    }
}
